import axios from "axios";
import { MessageBox, Message } from "element-ui";
import {
  setToken,
  getToken,
  removeToken,
  getUrl,
  setUrl,
  removeUrl,
  setphonenum,
  getphonenum
} from "@/common/cook";
axios.defaults.baseURL = "https://www.zhuoyuyun.com/";
// axios.defaults.baseURL = "/api";
// axios.defaults.baseURL = 'https://bk.zhuoyuyun.com/';

var token = window.localStorage.getItem("token");
axios.defaults.headers.post["Content-Type"] = "application/json";
if (getToken()) {
  axios.defaults.headers.post["token"] = getToken();
}

axios.defaults.validateStatus = function(status) {
  return status < 600; // Reject only if the status code is greater than or equal to 500
};

axios.$req = async function({
  url,
  method = method || "get",
  data,
  obj,
  success,
  fail,
  complete,
  ctx,
  params,
  headers,
  err
}) {
  try {
    var headers = Object.assign({}, {}, headers);
    var ctx = ctx || this;
    let { data, status } = await axios({
      url,
      method,
      data: obj,
      params,
      headers
    });
    if (!(status >= 200 && status <= 300)) {
      err && ctx && err.call(ctx, status);
    } else {
      // if(res.code==40004){
      // 	Message({
      // 		type:'warning',
      // 		message:'登录失效'
      // 	})
      // 	window.localStorage.clear()
      // }
      if (data.data == 1 || data.code == "10001" || data.code == 1) {
        ctx ? success.call(ctx, data) : success(data);
      } else if (data.data == -1) {
        // window.localStorage.removeItem("token");
        // if (window.localStorage.getItem("isRedirect") == 'not') {
        //   window.localStorage.setItem("isRedirect", 'is');
        //   MessageBox.confirm("您的登录已经失效，是否重新登录？", "提示", {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning'
        //   }).then(() => {
        //     window.localStorage.setItem("isRedirect", 'not');
        //     ctx.$router.push("/login/login");
        //   }).catch(err => {
        //     window.localStorage.setItem("isRedirect", 'not');
        //     ctx.$router.push("/login/login");
        //   })
        // }
      } else {
        fail && fail.call(ctx || null, data);
      }
    }
    complete && complete.call(ctx || null);
  } catch (err) {
    complete && complete.call(ctx || null);
  }
};
export default axios;



// WEBPACK FOOTER //
// ./src/common/http2.js